import queries from '@apis/queries';
import { useQuery } from '@tanstack/react-query';

function useInquiryTypes() {
  const { data } = useQuery(queries.inquiry.types());
  return data?.filter((type) => type.isActive);
}

export default useInquiryTypes;
